export const hospitalEncountersColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'financials__billing_status_code',
  'financials__billing_status_name',
  'financials__total_charges',
  'fk_hospital__clinical_id',
  'fk_hospital__data_doc_new_id',
  'fk_hospital__encounter_id',
  'metadata__correlation_derived_date',
  'metadata__correlation_id',
  'metadata__engagement_id',
  'metadata__engagement_name',
  'metadata__modified_by',
  'metadata__modified_date',
  'metadata__pipeline_id',
  'metadata__pipeline_name',
  'patient__enterprise_medical_record_number',
  'patient__medical_record_number',
  'patient__medicare_hic_number',
  'patient__patient_key',
  'patient__ucrn',
  'snapshot_id',
];
